import { backendApi } from "./backend.api";
import { ICar } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

interface ICarListQuery {
  spaceId?: number;
  ids?: number[];
}

const baseUrl = "/car";
export const carApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      cars: build.query<ICar[], ICarListQuery | null>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: ICarListQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: baseUrl,
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result
            ? [...result.map(({ id }) => ({ type: "Car" as const, id })), "Car"]
            : ["Car"],
      }),
      getCar: build.query<ICar, number>({
        query: (id) => ({ url: `${baseUrl}/${id}`, method: "GET" }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: "Car", id: item?.id }],
      }),
      addCar: build.mutation<ICar, Partial<ICar>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<ICar> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: baseUrl,
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["Car"],
        transformResponse: (response: { data: ICar }) => response.data,
      }),
      updateCar: build.mutation<ICar, Partial<ICar>>({
        query: (payload) => ({
          url: `${baseUrl}/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "Car", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      updateMultiCar: build.mutation<ICar[], ICar[]>({
        query: (payload) => ({
          url: baseUrl + "/update-multi",
          method: "POST",
          data: payload,
        }),
        invalidatesTags: (result = []) => [
          ...result.map(({ id }) => ({ type: "Car", id: id }) as const),
        ],
        // transformResponse: (response: { data: IVisit[] }) => response.data,
      }),
      deleteCar: build.mutation<ICar, number>({
        query: (id) => ({
          url: `${baseUrl}/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["Car"],
      }),
    };
  },
});

export const {
  useCarsQuery,
  useAddCarMutation,
  useDeleteCarMutation,
  useGetCarQuery,
  useUpdateCarMutation,
  useUpdateMultiCarMutation,
} = carApi;
